import { getFiltersByLocalStorageKey } from '../../Utilities/FilterUtilities'

const initialState = {
  activeCategory: null,
  descriptions: {},
  error: false,
  errorDetails: {
    message: null,
    code: null
  },
  filters: getFiltersByLocalStorageKey('MY_RECORDS_FILTERS'),
  lastRequestId: null,
  loading: false,
  recordDetailsLoading: false,
  results: null,
  resultsMode: 'table',
  selected: {},
  selectedDetails: null,
  selectedOwnershipRecords: [],
  selectedRecordHasOwners: null,
  showSelected: false,
  templates: {},
  userOwnsSelectedRecord: null
}

const MyRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@mr/RESET_STATE':
      return initialState
    case "@@mr/INVALIDATE_CACHE":
      return {
        ...state,
        results: null,
        selected: {},
        selectedDetails: null,
        showSelected: false
      }
    case '@@mr/SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategory: action.category
      }
    case 'SET_MY_RECORDS':
      return {
        ...state,
        results: { ...state.results, [action.category]: action.results.rows },
        templates: {
          ...state.templates,
          [action.category]: action.results.template
        }
      }
    case 'SELECT_MY_RECORDS_ROW':
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.category]: action.selected
        },
        showSelected:
          state.selected[action.category] !== action.selected && action.selected !== null
            ? true
            : !state.showSelected
      }
    case 'SET_MY_RECORDS_SELECTED_DETAILS':
      return { ...state, selectedDetails: action.details }
    case 'SET_MY_RECORDS_RESULTS_MODE':
      return { ...state, resultsMode: action.mode }
    case 'SET_MY_RECORDS_SELECTED_OWNERSHIP_RECORDS':
      return {
        ...state,
        selectedOwnershipRecords: action.selectedOwnershipRecords
      }
    case 'SET_RECORD_DETAILS_LOADING':
      return { ...state, recordDetailsLoading: action.loading }
    case 'SET_USER_OWNS_SELECTED_RECORD':
      return { ...state, userOwnsSelectedRecord: action.isOwner }
    case 'SET_SELECTED_RECORD_HAS_OWNERS':
      return { ...state, selectedRecordHasOwners: action.hasOwners }
    case '@@mr/SET_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.category]: action.filters
        }
      }
    case 'SET_MY_RECORDS_LOADING':
      return {
        ...state,
        loading: action.loading
      }
    case 'SET_MY_RECORDS_ERROR':
      return {
        ...state,
        error: action.error
      }
    case 'SET_MY_RECORDS_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails
      }
    case '@@mr/SET_REQUEST_ID':
      return { ...state, lastRequestId: action.requestId }
    case '@@MY_RECORDS_SET_DESCRIPTION':
      return {...state, descriptions: {...state.descriptions, [action.category]: action.description}}
    default:
      return state
  }
}

export default MyRecordsReducer



// WEBPACK FOOTER //
// ./src/components/MyRecords/MyRecordsReducer.js